// Shell do Service Level: sidebar/tema próprios (a experiência de "outra
// plataforma") com retorno explícito ao Insight Experience.
import { useEffect, useState } from 'react';
import { NavLink, Outlet, Link } from 'react-router-dom';
import { LayoutDashboard, Timer, ShieldCheck, Grid3x3, ArrowLeft, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { getFoto } from '../api';
import { useEscopo } from '../ServiceLevelContext';
import { fmtDataHoraFoto } from '../utils/format';
import { LogoImagem } from '../components/Logo';
import '../sl.css';

const activeCls = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : '');
const CHAVE_COMPACTA = 'sl_sidebar_compacta';

export default function ServiceLevelLayout() {
  const [foto, setFoto] = useState<string | null>(null);
  const [compacta, setCompacta] = useState(() => localStorage.getItem(CHAVE_COMPACTA) === '1');
  const escopo = useEscopo();
  const isAdmin = !!escopo?.is_admin;

  useEffect(() => {
    getFoto().then((r) => setFoto(r.ts_foto)).catch(() => {});
  }, []);

  const alternar = () => {
    setCompacta((v) => {
      localStorage.setItem(CHAVE_COMPACTA, v ? '0' : '1');
      return !v;
    });
  };

  const item = (to: string, Icone: typeof LayoutDashboard, rotulo: string, end = false) => (
    <NavLink to={to} end={end} className={activeCls} title={compacta ? rotulo : undefined}>
      <Icone size={17} /> <span className="rotulo">{rotulo}</span>
    </NavLink>
  );

  return (
    <div className="sl-root">
      <div className={`app ${compacta ? 'compacta' : ''}`}>
        <aside className="sidebar">
          <div className="logo">
            <div className="marca">
              <LogoImagem height={28} chip clara />
              <small>Nível de Serviço · Sellers</small>
            </div>
            <button
              type="button"
              className="sidebar-toggle desktop-only"
              onClick={alternar}
              title={compacta ? 'Expandir menu' : 'Recolher menu'}
              aria-label={compacta ? 'Expandir menu' : 'Recolher menu'}
            >
              {compacta ? <PanelLeftOpen size={18} /> : <PanelLeftClose size={18} />}
            </button>
          </div>

          <nav>
            {item('/service-level/dashboard', LayoutDashboard, 'Dashboard')}
            {isAdmin && (
              <>
                <div className="section">Administração</div>
                {item('/service-level/admin', ShieldCheck, 'Visão geral', true)}
                {item('/service-level/admin/sla-sellers', Timer, 'SLA por Seller')}
                {item('/service-level/admin/regioes-slas', Grid3x3, 'Regiões & SLAs')}
              </>
            )}
          </nav>

          <div className="sl-voltar">
            <Link to="/home" title="Voltar ao Insight Experience">
              <ArrowLeft size={15} /> <span>Voltar ao Insight Experience</span>
            </Link>
          </div>
          {foto && (
            <div className="px-5 pb-4 text-[11px] text-[#7a89a3] foto-rodape">
              Última atualização {fmtDataHoraFoto(foto)}
            </div>
          )}
        </aside>

        <div className="flex-1 flex flex-col min-w-0">
          <header className="topbar">
            <Link to="/service-level/dashboard" className="topbar-brand">
              <LogoImagem height={26} />
            </Link>
            <Link to="/home" className="sl-voltar-topo">
              <ArrowLeft size={15} /> Insight Experience
            </Link>
          </header>
          <main className="main">
            <Outlet />
          </main>
        </div>

        {/* navegação mobile */}
        <nav className="bottombar">
          <NavLink to="/service-level/dashboard" className={activeCls}>
            <LayoutDashboard size={19} /> Dashboard
          </NavLink>
          {isAdmin && (
            <NavLink to="/service-level/admin" end className={activeCls}>
              <ShieldCheck size={19} /> Admin
            </NavLink>
          )}
          <Link to="/home">
            <ArrowLeft size={19} /> Voltar
          </Link>
        </nav>
      </div>
    </div>
  );
}
